import {IconFont} from "../enums/icon-font";
import {ItemTagColor} from "../atoms/item-tag/item-tag-color";

export class ItemTag {
  beforeIcon?: IconFont;
  afterIcon?: IconFont;
  title: string = "";
  color: ItemTagColor = "white";
  clickable: boolean = false;
  size: "small" | "normal" = "normal";

  constructor() {
  }

  setTitle(newTitle: string): ItemTag {
    this.title = newTitle;
    return this;
  }

  setBeforeIcon(newBeforeIcon: IconFont): ItemTag {
    this.beforeIcon = newBeforeIcon;
    return this;
  }

  setAfterIcon(newAfterIcon: IconFont): ItemTag {
    this.afterIcon = newAfterIcon;
    return this;
  }

  setColor(newColor: ItemTagColor): ItemTag {
    this.color = newColor;
    return this;
  }

  setClickable(newClickable: boolean): ItemTag {
    this.clickable = newClickable;
    return this;
  }

  setSize(newSize: "small" | "normal" ): ItemTag {
    this.size = newSize;
    return this;
  }
}
